<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px" [@routeAnimation]="true">
    <mat-card style="background: #f7f7f7;">
        <mat-tab-group #tabGroup mat-stretch-tabs (selectedTabChange)="onTabChange($event.index)">

            <mat-tab label="Charitable Contributions">
                <div style="padding: 15px;" *ngIf="tabGroup.selectedIndex === 0">
                    <button mat-raised-button color="primary" (click)="editProjectTaskListCC()">Edit Project-Task List</button>
                </div>
                <!-- <div class="userHeading">
                                Selected Company List
                        </div> -->
                <projTask-table-component *ngIf="tabGroup.selectedIndex === 0" [data]='projectTaskCCDetails' [isLoading]='isLoadingProjectTaskDetails'>
                </projTask-table-component>
            </mat-tab>

            <mat-tab label="Community Investment/ Community Grants">
                <div style="padding: 15px;" *ngIf="tabGroup.selectedIndex === 1">
                    <button mat-raised-button color="primary" (click)="editProjectTaskListCI()">Edit Project-Task List</button>
                </div>
                <!-- <div class="userHeading">
                        Selected Company List
                </div> -->
                <projTask-table-component *ngIf="tabGroup.selectedIndex === 1" [data]='projectTaskCIDetails' [isLoading]='isLoadingProjectTaskDetails'>
                </projTask-table-component>
            </mat-tab>

            <mat-tab label="Plant for the Planet">
                <div style="padding: 15px;" *ngIf="tabGroup.selectedIndex === 2">
                    <button mat-raised-button color="primary" (click)="editProjectTaskListPFTP()">Edit Project-Task List</button>
                </div>
                <projTask-table-component *ngIf="tabGroup.selectedIndex === 2" [data]='projectTaskPPDetails' [isLoading]='isLoadingProjectTaskDetails'>
                </projTask-table-component>
            </mat-tab>
        </mat-tab-group>
    </mat-card>
</div>




<!-- <div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px" [@routeAnimation]="true">

    <button mat-raised-button color="primary" (click)="editProjectTaskList()">Edit Project-Task List</button>
    <mat-card>
        <h4>Selected Project-Task List</h4>
        <div class="cc-forms-container">
            <div class="cc-form-loading-shade" *ngIf="isLoadingProjectTaskDetails">
                <mat-spinner *ngIf="isLoadingProjectTaskDetails"></mat-spinner>
            </div>

            <mat-table class="mat-elevation-z8" #table [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="company">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Company </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.company}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="organization">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Organization </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.organization}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="account">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Account </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.account}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="project">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Project </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.project}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="task">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Task </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.task}} </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
        </div>
    </mat-card>
</div> -->